/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {
				// JavaScript to be fired on all pages
				var tablet = 992;

				setTimeout(function () {
					$("#page-loader").fadeOut();
				}, 2000);

				/* ================================================================================================== */

				$("button#search").off("click").on("click", function () {
					$(".search").not("body").stop().slideToggle("250", function ()  {
						$(this).find("#s").focus();
					});
				});

				$("div#menu button").off("click").on("click", function () {
					$("body").toggleClass("active-menu");
					$("html, body").animate({ scrollTop: 0 }, 1000);
					$(".nav-primary-mobile").slideToggle("250");
				});

				$(".nav-primary .menu-item-has-children").hover(function () {
					var submenu = $(this).find('.sub-menu');
					submenu.stop().slideToggle('250ms');
					var menu_offset = (submenu.offset().left + submenu.outerWidth());
					var head_offset = ($("header.banner .container").offset().left + $("header.banner .container").outerWidth());
					if ((head_offset - menu_offset) < 0) {
						submenu.css('right', 0);
					}
				});

				$(".nav-primary-mobile .menu-item-has-children").off("click").on("click", function (e) {
					if (!$(this).hasClass("opened")) {
						if ($(".menu-item-has-children").hasClass("opened")) {
							$(".opened .sub-menu").slideToggle("250");
							$(".opened").toggleClass("opened");
						}
						$(this).toggleClass("opened");
						$(this).find(".sub-menu").slideToggle("250");
					} else {
						$(".opened .sub-menu").slideToggle("250");
						$(".opened").toggleClass("opened");
					}
					if ($(e.target).is("a") && $(e.target).attr("href") == "#") {
						return false;
					}
				});

				$(".go-up").click(function() {
					$("html, body").animate({ scrollTop: 0 }, 1000);
				});

				$('.btn-more').on('click', function(e){
					e.preventDefault();
					$.each($(this).attr('class').split(/\s+/), function(index, item) {
						if (item.indexOf('open-') >= 0) {
							var itemToHide = $('.btn-more').parent().find('[class*=' + item.replace('open-','') + ']');
							if (itemToHide.hasClass('open')) {
								itemToHide.removeClass('open');
								$('.btn-more').removeClass('showing');
							} else{
								itemToHide.addClass('open');
								$('.btn-more').addClass('showing');
							}
						}
					});
				});

				$('.wpProQuiz_button').off('click').on('click', function() {
					$('.wpProQuiz_results').fadeOut('400',function(){
						$('.wpProQuiz_listItem').each(function(e){
							var actElm = $(this);
							if($(this).find('.wpProQuiz_correct').attr('style') == "display: none;"){
								actElm.addClass('wrong');
							}else{
								actElm.removeClass('wrong');
							}
						});
					});
				});

				// Pop up cookies
				
				var visits = getCookie('visits') || 0;
				visits++;				
				  
				setCookie('visits', visits, 30);

				if ( getCookie('visits') < 2 ) {
					$('.private-popup').addClass('open');	
				}

				$('.private-popup span').click(function(event) {
					$('.private-popup').removeClass('open');
					visits++;
				});

				if ($('#popup').length > 0) {
					window.popup = $('#popup');
					window.map = L.map('map', {
						center: L.latLng(41.330237,2.1174953),
						zoomControl: false,
						scrollWheelZoom: false,
						zoom: 16,
						minZoom: 1,
						maxZoom: 19,
						autoZIndex: true
					});
					new L.Control.Zoom({
						position: 'topleft'
					}).addTo(window.map);
					var	b = [2.111177444458008,41.336478215514376,2.1245670318603516,41.32442580362764];
					window.bounds = new L.LatLngBounds(new L.LatLng(b[1],b[0]), new L.LatLng(b[3],b[2]));
					map.addLayer(L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'));
					var tiles = L.tileLayer('http://maps.mercabarna.es/tiles/{z}/{x}/{y}.png', { maxZoom: 21, minZoom: 1 });
					map.addLayer(tiles);
					var mark = location.hash.replace('#',''), marker, marker2; //, p;
					L.Icon.Default.imagePath = 'http://www.mercabarna.es/media/css/img/maps/';
					var myIcon = L.icon({
						iconUrl: 'http://www.mercabarna.es/media/css/img/maps/marker-animated.gif',
						iconRetinaUrl: 'http://www.mercabarna.es/media/css/img/maps/marker-animated2x.gif',
						iconSize: [25,41],
						iconAnchor: [12.5, 41],
						popupAnchor: [-3, -76],
						shadowUrl: 'http://www.mercabarna.es/media/css/img/maps/void.png',
						shadowRetinaUrl: 'http://www.mercabarna.es/media/css/img/maps/void.png',
						shadowSize: [68, 95],
						shadowAnchor: [22, 94]
					});
					marker = new L.marker([41.331236,2.11478]);
					marker.addTo(map);
					map.on('click', function() {
						if (map.scrollWheelZoom.enabled()) {
							map.scrollWheelZoom.disable();
						} else {
							map.scrollWheelZoom.enable();
						}
					});
				}

				/* STICKY MENU ====================================================================================== */

				$(window).resize(function () { resize(); });				
				$(window).scroll(function () { scroll(); });

				setTimeout(function() {
					resize();	
					scroll();
				}, 1);

				function resize() {
					var top = ($(window).scrollTop() || $("body").scrollTop()),
						width = $(window).outerWidth(),
						marginTop = $("header.banner").outerHeight(),
						marginTop2 = 0;

					if ($("#wpadminbar").length > 0) {
						marginTop2 = marginTop;
						marginTop += $("#wpadminbar").outerHeight();
					}

					// Menú responsive corrección posición
					$(".nav-primary-mobile").css("top", marginTop);

					// Añadimos un margen superior al contenido de la web
					$(".wrap").css("margin-top", marginTop2);

					if (width > tablet) {
						$("body").removeClass("active-menu");
						$(".nav-primary-mobile").slideUp("250");
						$(".wrap").css("margin-top", marginTop2);
					} else {
						marginTop += 20;
					}

					// BreadCrumb
					$("#breadcrumb").css("padding-top", marginTop + 20);
					
				}

				function scroll() {
					var top = ($(window).scrollTop() || $("body").scrollTop()),
						width = $(window).outerWidth(),
						marginTop = $("header.banner").outerHeight(),
						marginTop2 = 0;

					if ($("#wpadminbar").length > 0) {
						marginTop2 = marginTop;
						marginTop += $("#wpadminbar").outerHeight();
					}

					// Menú responsive corrección posición
					$(".nav-primary-mobile").css("top", marginTop);

					if (width <= tablet) {
						// Añadimos un margen superior al contenido de la web
						$(".wrap").css("margin-top", marginTop2);
					}

					if (top > 0 || width < tablet) {
						$("body").addClass("sticky");						
					} else {
						$("body").removeClass("sticky");						
					}

					if (top > 80 && width < tablet) {
						$(".go-up").addClass('visible');
					} else {
						$(".go-up").removeClass('visible');
					}
				}

				function setCookie(cname, cvalue, exdays) {
				    var d = new Date();
				    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
				    var expires = "expires="+d.toUTCString();
				    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
				}

				function getCookie(cname) {
				    var name = cname + "=";
				    var ca = document.cookie.split(';');
				    for(var i = 0; i < ca.length; i++) {
				        var c = ca[i];
				        while (c.charAt(0) == ' ') {
				            c = c.substring(1);
				        }
				        if (c.indexOf(name) == 0) {
				            return c.substring(name.length, c.length);
				        }
				    }
				    return "";
				}

				function checkCookie() {
				    var user = getCookie("username");
				    if (user != "") {
				        alert("Welcome again " + user);
				    } else {
				        user = prompt("Please enter your name:", "");
				        if (user != "" && user != null) {
				            setCookie("username", user, 365);
				        }
				    }
				}

				/* ================================================================================================== */

				(function($) {
					// Browser supports HTML5 multiple file?
					var multipleSupport = typeof $('<input/>')[0].multiple !== 'undefined',
						isIE = /msie/i.test( navigator.userAgent );
					$.fn.customFile = function() {
						return this.each(function() {
							var $file = $(this).addClass('custom-file-upload-hidden'), // the original file input
								$wrap = $('<div class="file-upload-wrapper">'),
								$input = $('<input type="text" class="file-upload-input" />'),
								// Button that will be used in non-IE browsers
								$button = $('<button type="button" class="file-upload-button">' + $("#upload-translation").text() + '</button>'),
								// Hack for IE
								$label = $('<label class="file-upload-button" for="'+ $file[0].id +'">' + $("#upload-translation").text() + '</label>');
							// Hide by shifting to the left so we can still trigger events
							$file.css({
								position: 'absolute',
								left: '-9999px'
							});
							$wrap.insertAfter( $file ).append( $file, $input, ( isIE ? $label : $button ) );
							// Prevent focus
							$file.attr('tabIndex', -1);
							$button.attr('tabIndex', -1);
							$button.click(function () {
								$file.focus().click(); // Open dialog
							});
							$file.change(function() {
								var files = [], fileArr, filename;
								// If multiple is supported then extract all filenames from the file array
								if ( multipleSupport ) {
									fileArr = $file[0].files;
									for ( var i = 0, len = fileArr.length; i < len; i++ ) {
										files.push( fileArr[i].name );
									}
									filename = files.join(', ');
									// If not supported then just take the value and remove the path to just show the filename
								} else {
									filename = $file.val().split('\\').pop();
								}
								$input.val( filename ) // Set the value
								.attr('title', filename) // Show filename in title tootlip
								.focus(); // Regain focus
							});
							$input.on({
								blur: function() { $file.trigger('blur'); },
								keydown: function( e ) {
									if ( e.which === 13 ) { // Enter
										if ( !isIE ) { $file.trigger('click'); }
									} else if ( e.which === 8 || e.which === 46 ) { // Backspace & Del
										// On some browsers the value is read-only with this trick we remove the old input and add a clean clone with all the original events attached
										$file.replaceWith( $file = $file.clone( true ) );
										$file.trigger('change');
										$input.val('');
									} else if ( e.which === 9 ){ // TAB
										return;
									} else { // All other keys
										return false;
									}
								}
							});
						});
					};
					// Old browser fallback
					if ( !multipleSupport ) {
						$( document ).on('change', 'input.customfile', function() {
							var $this = $(this),
								// Create a unique ID so we can attach the label to the input
								uniqId = 'customfile_'+ (new Date()).getTime(),
								$wrap = $this.parent(),
								// Filter empty input
								$inputs = $wrap.siblings().find('.file-upload-input').filter(function(){ return !this.value }),
								$file = $('<input type="file" id="'+ uniqId +'" name="'+ $this.attr('name') +'"/>');
							// 1ms timeout so it runs after all other events that modify the value have triggered
							setTimeout(function() {
								// Add a new input
								if ( $this.val() ) {
									// Check for empty fields to prevent creating new inputs when changing files
									if ( !$inputs.length ) {
										$wrap.after( $file );
										$file.customFile();
									}
									// Remove and reorganize inputs
								} else {
									$inputs.parent().remove();
									// Move the input so it's always last on the list
									$wrap.appendTo( $wrap.parent() );
									$wrap.find('input').focus();
								}
							}, 1);
						});
					}
				}(jQuery));
				$('input[type=file]').customFile();
			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
				var paddingTop = $("header.banner").outerHeight(), width = $(window).outerWidth(), tablet = 992;

				if (width < tablet) {
					$(".main").css("padding-top", paddingTop);
				} else {
					$(".main").removeAttr("style");
				}

				var mySwiper = new Swiper ('#slider-home', {
					autoplay: 5000,
					autoplayDisableOnInteraction: false,
					direction: 'vertical',
					loop: true,
					loopedSlides: 0,
					pagination: '.swiper-pagination',
					paginationClickable: true,
					parallax: true,
					slidesPerView: 'auto',
					speed: 2500,
				});

				setTimeout(function(){
					mySwiper.update(true);
					mySwiper.slideTo(0, 0);
				}, 100);

				resizeSlider();

				$(window).resize(function () {
					resizeSlider();
					paddingTop = $("header.banner").outerHeight(), width = $(window).outerWidth();
					if (width < tablet) {
						$(".main").css("padding-top", paddingTop);
					} else {
						$(".main").removeAttr("style");
					}
				});

				function resizeSlider() {
					var slide_height, maxHeight;
					$(".slide-1").each(function (key, value) {
						slide_height = $(value).find("img").height();
						if (slide_height >= 840) {
							maxHeight = slide_height = 840;
						} else {
							maxHeight = "none";
						}
						$(".slide-1").find("img").css("max-height", maxHeight);
						$("#slider-home").height(slide_height);
						$(".slide").height(slide_height);
					});
				}				
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.